import ReactDOM from "react-dom/client";
import { BrowserRouter} from 'react-router-dom';
import Base from './components/access/Base';
import { REF_CURRENT_USER_ID} from 'nexus-common/src/components/access/constants';
import Cookies from 'universal-cookie';
import { useEffect, useRef, useState } from "react";
import { ConfigProvider } from 'antd';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cookies = new Cookies();

const emotionCache = createCache({
  key: 'css',
  nonce: 'scui-nonce',
  prepend: true,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const RenderApp = () => {
  const [cookieAvailable, setCookieAvailable] = useState(!!cookies.get(REF_CURRENT_USER_ID))
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const intervalRefStopped = useRef(false)
  
  useEffect(() => {
    if(cookieAvailable) {
      intervalRefStopped.current = true;
      return;
    }

    const checkCookie = () => {
      const currCookie = !!cookies.get(REF_CURRENT_USER_ID);
      if(currCookie !== cookieAvailable) {
        setCookieAvailable(currCookie)
        if(currCookie) {
          if(intervalRef.current) {
            clearInterval(intervalRef.current) 
            intervalRef.current = null;
            intervalRefStopped.current = true
          }
        }
      }
    }

    if(!intervalRefStopped.current) {
      intervalRef.current = setInterval(checkCookie, 1000)
    }

    return () => {
      if(intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }

  }, [cookieAvailable])

  return (
    <CacheProvider value={emotionCache}>
      <ConfigProvider>
        <BrowserRouter>
          <Base
            user={
                undefined
              }
          />
        </BrowserRouter>
      </ConfigProvider>
    </CacheProvider>
  );
}

root.render(<RenderApp/>)
